export const LEVELS = {
  job: 'job',
  stage: 'stage',
  pipeline: 'pipeline',
}
